module.exports = __webpack_public_path__ + "static/media/ca_12.72cb6a42.png";